export const dateFormat = 'MM/DD/YYYY';
export const dateTimeFormat = 'MM/DD/YYYY hh:mm A';
export const dateTimeFormatWithDot = 'MM/DD/YYYY · hh:mm A';
